import Vue from 'vue';

const Files = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        fetchFromS3: ({state, dispatch, commit}, payload) => {
            return Vue.prototype.$S3Service
                .get(payload.url, payload.config)
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    console.log(err.response);
                    return err;
                });
        },

        downloadCO: ({rootState}, payload) => {
            let formData = new FormData();

            formData.append("cube_pixels", payload.cube_pixels);
            formData.append('cube_meta', payload.cube_meta);

            return Vue.prototype.$apiService
                .post(`accounts/${rootState.User.account.id}/download-co`, formData, {
                    responseType: 'blob'
                })
                .catch(() => null)
        },

        downloadLuts: ({rootState}, payload) => {
            let formData = new FormData();

            if (payload.cube_pixels && payload.cube_meta) {
                formData.append("cube_pixels", payload.cube_pixels);
                formData.append('cube_meta', payload.cube_meta);
            }

            if (payload.vlt_pixels && payload.vlt_meta) {
                formData.append("vlt_pixels", payload.vlt_pixels);
                formData.append('vlt_meta', payload.vlt_meta);
            }

            if (payload.ipp2_pixels && payload.ipp2_meta) {
                formData.append("ipp2_pixels", payload.ipp2_pixels);
                formData.append('ipp2_meta', payload.ipp2_meta);
            }

            if (payload.davinci_pixels && payload.davinci_meta) {
                formData.append("davinci_pixels", payload.davinci_pixels);
                formData.append('davinci_meta', payload.davinci_meta);
            }

            if (payload.logc4_pixels && payload.logc4_meta) {
                formData.append("logc4_pixels", payload.logc4_pixels);
                formData.append('logc4_meta', payload.logc4_meta);
            }

            return Vue.prototype.$apiService
                .post(`accounts/${rootState.User.account.id}/download-luts`, formData)
                .catch(() => null)
        },

        downloadFreeLutsPackage: ({ rootState }) => {
            return Vue.prototype.$apiService
              .get(`accounts/${rootState.User.account.id}/download-free-luts-package`)
              .then(({ data }) => {
                return data
              })
              .catch(() => null)
        }
    },
    getters: {}
};

export default Files;
